export default __webpack_public_path__ + "static/media/check_in_circle.fb824359.svg";